var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "vp-container" } },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header canvas",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "8" } }, [
                _c("div", { staticClass: "d-flex" }, [
                  _c("img", {
                    staticClass: "back-to-list-apps",
                    attrs: { src: require("@/assets/icon/arrow-left.svg") },
                    on: {
                      click: function($event) {
                        _vm.$router.push("/canvas")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "auto__label-head ellipsis" }, [
                    _vm._v("\n            " + _vm._s(_vm.name_canvas) + " "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.dataDetail ? _vm.dataDetail.id : ""))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "4" } }, [
                _c("i", {
                  staticClass:
                    "fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--8",
                  attrs: { id: "configPopover" }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "btn-save-action-canvas pull-right m__r--5",
                    on: { click: _vm.saveCanvas }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icon/check-blue.png"),
                        width: "17"
                      }
                    }),
                    _vm._v("\n          Save\n        ")
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { attrs: { id: "vp-container-tab" } },
            [
              _c(
                "b-col",
                {
                  staticClass: "studio-page-tab centered p__t--24",
                  class: {
                    "studio-page-tab-active": _vm.modeCanvas === "list"
                  },
                  on: {
                    click: function($event) {
                      _vm.selectTab("list")
                    }
                  }
                },
                [
                  _c("h4", [_vm._v("WIDGET LIST")]),
                  _vm._v(" "),
                  _vm.modeCanvas === "list"
                    ? _c("div", { staticClass: "underline-data" })
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "studio-page-tab centered p__t--24",
                  class: {
                    "studio-page-tab-active": _vm.modeCanvas === "config"
                  },
                  on: {
                    click: function($event) {
                      _vm.selectTab("config")
                    }
                  }
                },
                [
                  _c("h4", [_vm._v("CONFIG")]),
                  _vm._v(" "),
                  _vm.modeCanvas === "config"
                    ? _c("div", { staticClass: "underline-data" })
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-widget" }, [
        _vm.modeCanvas === "list" && _vm.dataDetail
          ? _c(
              "div",
              [
                _c(
                  "draggable",
                  {
                    model: {
                      value: _vm.dataDetail.widgets,
                      callback: function($$v) {
                        _vm.$set(_vm.dataDetail, "widgets", $$v)
                      },
                      expression: "dataDetail.widgets"
                    }
                  },
                  [
                    _c(
                      "transition-group",
                      _vm._l(_vm.dataDetail.widgets, function(data, index) {
                        return _c(
                          "div",
                          {
                            key: index + 0,
                            staticClass: "list-column-ui canvas-item"
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-center cursor-pointer",
                                    attrs: { md: "1" }
                                  },
                                  [
                                    data.type == "line_chart"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/canvas/linechart.png"),
                                            width: "30"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.type == "pie_chart"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/canvas/piechart.png"),
                                            width: "30"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.type == "bar_chart"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/canvas/barchart.png"),
                                            width: "30"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.type == "text"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/canvas/text.png"),
                                            width: "30"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.type == "table"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/canvas/table.png"),
                                            width: "30"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.type == "map"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/canvas/map.png"),
                                            width: "30"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    data.type == "progress_bar"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/canvas/progress_bar.png"),
                                            width: "30"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "10" } }, [
                                  _c(
                                    "div",
                                    { staticClass: "canvas--label-widget" },
                                    [_vm._v(_vm._s(data.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "canvas--label-widget-data"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            data.type === "table"
                                              ? data.form_ui_name
                                              : data.form_data_name
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex align-items-center justify-content-center",
                                    attrs: { md: "1" }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-2x fa-pencil cursor-pointer m__r--8",
                                      on: {
                                        click: function($event) {
                                          _vm.openModalWidget(data, index)
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "fa fa-2x fa-trash cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.deleteWidget(index)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "add-canvas-item",
                    attrs: { id: "widget-add" },
                    on: {
                      click: function($event) {
                        _vm.openModalWidget(null)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "icon-plus", attrs: { id: "widgetAdd" } },
                      [_vm._v("\n          +\n        ")]
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.modeCanvas === "config" && _vm.dataDetail
          ? _c("div", [
              _c(
                "div",
                { staticClass: "canvas-config mb-4" },
                [
                  _c("h4", [_vm._v("Display Timeframe")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "If active, the timeframe will be filterable from the dashboard"
                    )
                  ]),
                  _vm._v(" "),
                  _c("j-toggle", {
                    staticClass: "toggle-config",
                    attrs: {
                      disabled:
                        !_vm.dataDetail.widgets ||
                        _vm.dataDetail.widgets.length === 0
                    },
                    model: {
                      value: _vm.isShowTimeframe,
                      callback: function($$v) {
                        _vm.isShowTimeframe = $$v
                      },
                      expression: "isShowTimeframe"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "canvas-config" },
                [
                  _c("div", [_vm._v("Search Options List")]),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      model: {
                        value: _vm.dataDetail.search_options_list,
                        callback: function($$v) {
                          _vm.$set(_vm.dataDetail, "search_options_list", $$v)
                        },
                        expression: "dataDetail.search_options_list"
                      }
                    },
                    [
                      _c(
                        "transition-group",
                        { staticClass: "row-drag" },
                        _vm._l(_vm.dataDetail.search_options_list, function(
                          data,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "list-column-ui col-drag-12"
                            },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-center cursor-pointer p__l--1 p__r--1",
                                      attrs: { md: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-2x fa-ellipsis-v"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "p__l--1 p__r--1",
                                      attrs: { md: "4" }
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "0px !important"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(data.name) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(data.type) +
                                            "\n                  "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex align-items-center p__l--5 p__r--1",
                                      attrs: { md: "4" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(data.field_data_key) +
                                            "\n                  "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-end cursor-pointer p__l--1 p__r--1",
                                      attrs: { md: "2" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-lg fa-pencil m__r--8",
                                        on: {
                                          click: function($event) {
                                            _vm.openModalEditField(data, index)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa fa-lg fa-trash",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteField(index)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-add-column",
                      on: {
                        click: function($event) {
                          _vm.openModalEditField(null, null)
                        }
                      }
                    },
                    [_vm._v("\n          + Add field\n        ")]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalForm",
          staticClass: "mod-form modal-form-canvas",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "div",
            [
              _vm.isOpen
                ? _c("j-widget-form", {
                    attrs: { "field-detail": _vm.selectedField },
                    on: {
                      "close-modal": _vm.closeModalEditField,
                      "submit-mode": _vm.submitField
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "configPopoverRef",
          attrs: {
            show: _vm.configPopoverShow,
            target: "configPopover",
            placement: "left"
          },
          on: {
            "update:show": function($event) {
              _vm.configPopoverShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "add-automation", on: { click: _vm.renameCanvas } },
            [_vm._v("Rename")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "add-automation", on: { click: _vm.removeCanvas } },
            [_vm._v("Delete")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalFormField",
          staticClass: "mod-form modal-create-view",
          attrs: {
            id: "modal-form",
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "div",
            [
              _vm.isOpenField
                ? _c("j-column-edit", {
                    attrs: {
                      "field-detail": _vm.selectedField,
                      "variable-options": _vm.variableOptionsFilter,
                      "is-search": true,
                      "field-ui-key": _vm.dataDetail.search_options_list
                    },
                    on: {
                      "close-modal": _vm.closeModalEditField,
                      "submit-mode": _vm.submitFieldSearch
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "updateNameModal",
          staticClass: "mod-form",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.name_canvas.$error } },
            [
              _c("label", [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: { "max-length": 255, placeholder: "Name" },
                model: {
                  value: _vm.$v.name_canvas.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.name_canvas, "$model", $$v)
                  },
                  expression: "$v.name_canvas.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-right m__t--20" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn m__r--5",
                  on: { click: _vm.closeRenameCanvas }
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { staticClass: "btn blue", on: { click: _vm.saveCanvas } },
                [_vm._v("\n        Update\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76aacc14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76aacc14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/canvas/jCanvasDetail.vue
// module id = null
// module chunks = 